import { Component, OnInit, HostBinding, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { routerTransition } from 'app/shared/animations/router-transition.animation';
import { BehaviorSubject } from 'rxjs/Rx';
import { Subscription } from 'rxjs/Subscription';
import { AcompanhamentoService } from '../shared/acompanhamento.service';
import { ModalService } from 'app/shared/modal/modal.service';
import { DadosPagamento } from 'models/dados-pagamento';
import { BoletoService } from 'app/shared/pagamento/boleto/boleto.service';

@Component({
  selector: 'app-inscricoes',
  templateUrl: './inscricoes.component.html',
  styleUrls: ['./inscricoes.component.scss'],
  animations: [routerTransition],
})
export class InscricoesComponent implements OnInit, OnDestroy {
  @HostBinding('@routerTransition') routerTransition = true;
  @HostBinding('style.display') display = 'block';

  candidato: any = {};
  inscricoes: any = [];
  url: BehaviorSubject<string>;
  urlObservable: Subscription;
  dadosPagamento: BehaviorSubject<DadosPagamento> = new BehaviorSubject<DadosPagamento>(new DadosPagamento({}));
  dadosPagamentoBoleto: DadosPagamento;
  private obsDadosPagamento: Subscription;

  menuCandidato = [
    {
      nome: 'MINHAS INSCRIÇÕES',
      link: '/pos-graduacao/inscricoes',
      ativo: true,
      icone: 'list',
      clicavel: true,
    },
    {
      nome: 'SAIR',
      link: '/pos-graduacao/acompanhamento',
      icone: 'sair',
      clicavel: true,
    },
  ];

  constructor(
    private router: Router,
    private acompanhamentoService: AcompanhamentoService,
    private modalService: ModalService,
    private boletoService: BoletoService,
  ) {
    let url = '';
    this.urlObservable = this.router.events.subscribe((evento) => {
      if (evento instanceof NavigationEnd) {
        url = evento.url;
        this.url.next(url);
      }
    });

    if (!this.acompanhamentoService.getDadosInscricoes()) {
      this.router.navigate([`./pos-graduacao/acompanhamento`]);
    }

    this.url = new BehaviorSubject<string>(url);
  }

  ngOnInit() {
    const { pessoa, inscricoes } = this.acompanhamentoService.getDadosInscricoes();
    this.candidato = pessoa;
    this.inscricoes = inscricoes;
  }

  ngOnDestroy() {
    if (this.urlObservable) {
      this.urlObservable.unsubscribe();
    }
    if (this.obsDadosPagamento) {
      this.obsDadosPagamento.unsubscribe();
    }
  }

  configuraTurno(turno) {
    switch (turno) {
      case 'I':
        return 'Integral';
      case 'M':
        return 'Matutino';
      case 'V':
        return 'Vespertino';
      case 'N':
        return 'Noturno';
    }
  }

  configuraStatusPagamento(status) {
    switch (status) {
      case 'ABERTO':
        return 'Aguardando Pagamento';
      case 'QUITADO':
        return 'Pagamento Efetuado';
      case 'EXPIRADO':
        return 'Prazo para pagamento do boleto expirou';
      case 'BLOQUEADO':
        return 'Bloqueado (procurar central)';
    }
  }

  onPagamentoSucesso(event) {
    const pago = event.id === 'cartao';

    if (pago) {
      this.modalService.close('alterar-pagamento');
      window.location.reload();
    } else {
      this.modalService.close('alterar-pagamento');
    }
  }

  alterarFormaPagamento(inscricao) {
    this.geraDadosPagamento(inscricao);
    this.modalService.open('alterar-pagamento');
  }

  gerarBoleto(inscricao) {
    this.geraDadosPagamento(inscricao);
    this.obsDadosPagamento = this.dadosPagamento.subscribe((dadosPagamento: DadosPagamento) => {
      this.dadosPagamentoBoleto = dadosPagamento;
    });
    this.boletoService.gerarPDF(this.dadosPagamentoBoleto);
  }

  geraDadosPagamento(inscricao) {
    const { cpf, nome } = this.candidato;
    const valorInscricao = inscricao.pagamento.valorInscricao;
    this.dadosPagamento.next(new DadosPagamento({
      dadosPessoais: {
        cpd: 0,
        cpf,
        nome,
        numInscricao: inscricao.id,
      },
      valorTotal: valorInscricao,
      sistema: {
        codigoSistema: 5,
        nomeSistema: 'POS GRADUACAO',
        servico: {
          codigo: 14,
          descricao: 'Pagamento de Inscrição Pós-Graduação',
          valorTotal: valorInscricao,
        },
      },
    }));
  }
}
